import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { PRIVACY_POLICY } from './legalContent';

function PrivacyPolicy() {
  return <LegalPageLayout {...PRIVACY_POLICY} />;
}

export default PrivacyPolicy;
